module.exports = "/_next/static/images/lock-12f69faf08acb627834de6e6c758e960.svg";